import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import cx from "classnames";

const ReceiptQrCodeGuestManagementCallout = ({
    allQrCodesGenerated = false,
    email = "",
    handlePluralManageTicketsLinkLabel = "",
    handlePluralViewTicketsButtonLabel = "",
    handledPluralEmailedTicketCount = "",
    hasGuestManagementAvailable = false,
    hasQrCodesAvailable = false,
    includeManagedEmailCount = false,
    isMediumScreen = false,
    manageTicketsUrlComplete = "",
    numberOfQrCodes = 0,
    qrCodeUrlComplete = "",
    ticketConfirmationMessageArray = [],
}) => {
    if (hasQrCodesAvailable || hasGuestManagementAvailable) {
        return (
            <div className="col col--12 -padding-left--0">
                <div
                    className={cx(
                        "ticket-message -callout -text--center",
                        isMediumScreen && "ticket-message--full",
                    )}
                >
                    <span>
                        {ticketConfirmationMessageArray[0]}{" "}
                        <strong className="font-weight--bold">
                            {email}
                            {includeManagedEmailCount &&
                                handledPluralEmailedTicketCount}
                        </strong>{" "}
                        {ticketConfirmationMessageArray[1]}
                    </span>
                    {((hasQrCodesAvailable && allQrCodesGenerated) ||
                        hasGuestManagementAvailable) &&
                        (isMediumScreen ? (
                            <br />
                        ) : (
                            <span className="-margin-left--10 -margin-right--10">
                                |
                            </span>
                        ))}
                    <span
                        className={
                            isMediumScreen
                                ? "-margin-top--10 -display--block"
                                : ""
                        }
                    >
                        {hasQrCodesAvailable && allQrCodesGenerated && (
                            <a
                                href={qrCodeUrlComplete}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Icon
                                    ariaHidden
                                    className="-type--large -margin-right--10 -margin-left--5"
                                    glyph={
                                        numberOfQrCodes > 1
                                            ? "tickets-solid"
                                            : "ticket-solid"
                                    }
                                    type={
                                        numberOfQrCodes > 1
                                            ? "Custom"
                                            : "FontAwesome"
                                    }
                                />
                                <strong>
                                    {handlePluralViewTicketsButtonLabel}
                                </strong>
                            </a>
                        )}

                        {hasQrCodesAvailable && hasGuestManagementAvailable && (
                            <span className="-margin-left--10 -margin-right--10">
                                |
                            </span>
                        )}
                        {hasGuestManagementAvailable && (
                            <a
                                href={manageTicketsUrlComplete}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Icon
                                    ariaHidden
                                    className="-type--large -margin-right--10 -margin-left--5"
                                    glyph="pencil-solid"
                                    type="FontAwesome"
                                />
                                <strong>
                                    {handlePluralManageTicketsLinkLabel}
                                </strong>
                            </a>
                        )}
                    </span>
                </div>
            </div>
        );
    }
    return <div className="col col--12 -padding-left--0" />;
};

ReceiptQrCodeGuestManagementCallout.propTypes = {
    allQrCodesGenerated: PropTypes.bool,
    hasQrCodesAvailable: PropTypes.bool,
    hasGuestManagementAvailable: PropTypes.bool,
    isMediumScreen: PropTypes.bool,
    qrCodeUrlComplete: PropTypes.string,
    numberOfQrCodes: PropTypes.number,
    handlePluralViewTicketsButtonLabel: PropTypes.string,
    manageTicketsUrlComplete: PropTypes.string,
    handlePluralManageTicketsLinkLabel: PropTypes.string,
    ticketConfirmationMessageArray: PropTypes.arrayOf(PropTypes.string),
    email: PropTypes.string,
    includeManagedEmailCount: PropTypes.bool,
    handledPluralEmailedTicketCount: PropTypes.string,
};

export default ReceiptQrCodeGuestManagementCallout;
